import {
  Component,
  OnInit
} from '@angular/core';

import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';

import { TweenMax, TimelineMax } from "gsap";
import * as $ from 'jquery/dist/jquery.min.js';
import { BrowserModule, Title }  from '@angular/platform-browser';


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'membership',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./membership.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./membership.component.html')
})
export class MembershipComponent implements OnInit {
  /**
   * Set our default values
   */
  public localState = { value: '' };
  fees:any;
  misc = "assets/images/MISC.jpg";
  offset = 250;
  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title
  ) {}

  public ngOnInit() {
    // console.log('hello `membership` component');
        this.title.setTitle("The Tiger Club | Memberships");

     this.fees = this.appState.getFees();
     // console.log("this ", this.fees.tiger.normal);
     

    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
     // $("#main_header").addClass("after_scroll");


    //  var scene = new this.appState.ScrollMagic.Scene({
    //   triggerElement: "#trigger",
    //   duration: 60
    // })
    //   .setTween(TweenMax.to(this.test.nativeElement, 0.5, { y: -40 }))
    //   .addTo(this.appState.controller);


     
  }

  public more_tiger(){
    $("#more_tiger").removeClass("collapsed");
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 1000);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/membership/membership.component.ts